import styles from "../AudioRecorder.module.scss";
import { ReactComponent as WarningIcon } from "assets/svg/warning-icon.svg";
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import messages from "messages";
import IconButton from "components/icon-button";

const BackupWarning = ({ onDismiss }) => {
  const warningMessage = messages.audioRecordingBackupWarning.split(".", 2);
  return (
    <div className={styles["backup-warning"]}>
      <WarningIcon />
      <span className={styles["backup-warning__text"]}>
        <strong>{warningMessage[0]}.</strong> {warningMessage[1]}
      </span>
      <IconButton onClick={onDismiss}>
        <OutlineCross />
      </IconButton>
    </div>
  );
};

export default BackupWarning;
